<template>
  <div>
    <b-card-code
        title="Szerkesztés"
    >
      <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
      >
        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="12">
                <b-form-group
                    :label="formData.title"
                    :description="formData.description"
                >
                  <validation-provider
                      #default="{ errors }"
                      :name="formData.title"
                      rules="required"
                      vid="value"
                  >
                    <editor
                        v-model="formData.value"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit button -->
              <b-col class="mt-1">
                <b-button
                    variant="primary"
                    type="submit"
                    class="float-right"
                    @click.prevent="submitForm"
                >
                  Mentés
                </b-button>
                <cancel-and-g-o-t-o-previous-page class="mr-2"/>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-card-code>
    <b-card-code>
      <tabs
          ref="tabs"
          :entity-id="parseInt(this.$route.params.id)"
      />
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BOverlay
} from 'bootstrap-vue'
import {
  required, email,
} from '@validations'
import tabs from '@/views/pages/_components/_tabs/_textTemplate/update.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import editor from '@/views/pages/_components/editor.vue'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BOverlay,
    tabs,
    editor,
    cancelAndGOTOPreviousPage,
  },
  data() {
    return {
      role: 'text_template',
      loading: false,
      formData: {
        id: null,
        title: '',
        value: '',
        description: '',
      },
      required,
      email,
    }
  },
  created() {
    this.loading = true

    this.$store.dispatch('fetchTextTemplate', this.$route.params.id).then(response => {
      this.formData = response.data.entity
      this.formData.id = this.$route.params.id
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loading = true

          let fd = JSON.parse(JSON.stringify(this.formData))

          this.$store.dispatch('updateTextTemplate', fd).then(() => {
            this.$refs.tabs.refreshLog()
            this.$helpers.showSuccessToast('Szövegsablon módosítva.')

            this.$acl.canListPermission(this.role)
                ? this.$router.push({name: 'text-templates'})
                : this.$router.go(-1)
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>
